import { render, staticRenderFns } from "./widgetSearchUserInput.vue?vue&type=template&id=435fac04&scoped=true"
import script from "./widgetSearchUserInput.vue?vue&type=script&lang=js"
export * from "./widgetSearchUserInput.vue?vue&type=script&lang=js"
import style0 from "./widgetSearchUserInput.vue?vue&type=style&index=0&id=435fac04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435fac04",
  null
  
)

export default component.exports